import {Fab, styled} from '@mui/material';

export const StyledFab = styled(Fab)`
	position: fixed;
	z-index: 1;
	bottom: 62px;
	right: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		right: 32px;
	}

	${({theme}) => theme.breakpoints.up('lg')} {
		bottom: 32px;
		right: 48px;
	}
`;
